// @ts-ignore
export { default as default } from './AuthModal';
